import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Heading, Typography, Link } from '@klp/design';
import { Box, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { useTranslation } from 'react-i18next';
import { KlpPalette } from '@klp/design/Theme/KlpPalette';
import {
    surveySelectorActions,
    surveySelectorSelectors,
} from '../store/surveySlice';
import { useCurrentUser } from '@klp/auth';

export default function Survey() {
    const { t } = useTranslation();
    const useStyles = makeStyles(() => ({
        surveyContainer: {
            position: 'relative',
        },
        survey: {
            backgroundColor: KlpPalette.secondary.light,
            position: 'relative',
            width: 'fit-content',
            maxWidth: '60%',
            borderRadius: '10px',
            padding: '25px',
            top: 0,
            left: 0,
            marginBottom: '40px',
            filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
            '&::after': {
                content: '""',
                position: 'absolute',
                borderStyle: 'solid',
                borderWidth: '15px 15px 0',
                borderColor: '#e3f9ed transparent transparent',
                display: 'block',
                bottom: '-15px',
                left: '20%',
                marginLeft: '-15px',
                filter: 'drop-shadow(1px 2px 0 transparent)',
            },
        },
        surveyIconButton: {
            position: 'absolute',
            top: '8px',
            right: '8px',
        },
    }));

    const classes = useStyles();
    const dispatch = useDispatch();
    const { currentUser } = useCurrentUser();
    const { hideSurvey } = useSelector(surveySelectorSelectors);

    const { saveHideSurveyToStorage } = surveySelectorActions;

    const handleHideSurvey = () => {
        dispatch(saveHideSurveyToStorage(true));
    };

    const startDate: Date = new Date(2023, 6, 18);
    const endDate: Date = new Date(2023, 9, 19);
    const today: Date = new Date();
    const isWithinTimePeriod: boolean = startDate <= today && today <= endDate;

    return (
        <>
            {isWithinTimePeriod && !hideSurvey && currentUser && (
                <Box className={classes.surveyContainer}>
                    <Box className={classes.survey}>
                        <IconButton
                            className={classes.surveyIconButton}
                            onClick={handleHideSurvey}
                        >
                            <Illustration
                                icon={IconName.CLOSE}
                                size="xsmall"
                                klpPalette="secondary"
                            />
                        </IconButton>
                        <Heading
                            klpHeadingLevel="FOUR"
                            translation="frontPage.survey.title"
                            translationOptions={{
                                name:
                                    currentUser.fornavn !== null
                                        ? ', ' + currentUser.fornavn
                                        : '',
                            }}
                            align="left"
                            data-cy="Frontpage__Title"
                        />{' '}
                        <Typography paddingTop="tiny" paddingBottom="compact">
                            {t('frontPage.survey.description1')}{' '}
                            {t('frontPage.survey.description2')}
                        </Typography>
                        <Link
                            target="_blank"
                            href="https://forms.gle/vLNgP1aSYquBaRy28"
                            externalLink={true}
                            translation="frontPage.survey.linkText"
                        />
                    </Box>
                </Box>
            )}
        </>
    );
}
